import { render } from "./DataStructuring.vue?vue&type=template&id=32ce957a&scoped=true"
import script from "./DataStructuring.vue?vue&type=script&lang=js"
export * from "./DataStructuring.vue?vue&type=script&lang=js"

import "./DataStructuring.vue?vue&type=style&index=0&id=32ce957a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ce957a"]])

export default __exports__